import { useCallback } from 'react';
import { useRemoveBonus } from 'server';
import { useFetchBalance } from 'js/hooks/user';
import { useIsMounted } from 'js/hooks/useIsMounted';

import * as actions from 'js/components/main/BonusHistory/store/actions';
import { useDynamicReducerDispatch } from 'js/components/main/BonusHistory/store';
import { dispatcher } from 'dispatcher';
import { useTranslations } from 'js/hooks/i18n';
import { useShowPopupWithClass } from '@theme/js/hooks/swiss/useShowPopupWithClass';
import { REMOVE_BONUS_POPUP_ERROR_TITLE } from '@theme/js/hooks/swiss/useShowPopupWithClass/constants';

export const useCancelBonus = () => {
    const isMounted = useIsMounted();
    const fetchBalance = useFetchBalance();
    const dispatch = useDynamicReducerDispatch();
    const removeBonus = useRemoveBonus();
    const t = useTranslations();
    const content = t(REMOVE_BONUS_POPUP_ERROR_TITLE);
    const showPopup = useShowPopupWithClass();

    return useCallback((bonusInstanceCode: string): void => {
        dispatch(actions.toggleLoading(true));

        (async () => {
            try {
                await removeBonus(bonusInstanceCode);
                await fetchBalance();
                dispatcher.dispatch('notification-bonusCounter:updated');
                isMounted() && dispatch(actions.updatePeriod());
            } catch (error) {
                isMounted() && showPopup({
                    className: 'bonus-cancel-popup',
                    content
                });
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [content, dispatch, fetchBalance, isMounted, removeBonus, showPopup]);
};
